// extracted by mini-css-extract-plugin
module.exports = {"shadowOnHover":"shadowOnHover_shadowOnHover__SOsz_","darkShadowOnHover":"shadowOnHover_darkShadowOnHover__CYmYF"};